interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
      style={{ height: '72px' }}
    >
      <div className="max-w-7xl mx-auto px-8 h-full flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="https://public.readdy.ai/ai/img_res/ce3861b4-1e99-4774-b56d-0a3e475a675b.png" 
            alt="TEAL SRL Logo" 
            className="h-10 w-10 object-contain"
          />
          <span className="text-xl font-semibold" style={{ color: '#0A4D4D' }}>
            TEAL SRL
          </span>
        </div>
        <ul className="flex items-center gap-10">
          {['home', 'about', 'products', 'features', 'contact'].map((item) => (
            <li key={item}>
              <button
                onClick={() => scrollToSection(item)}
                className="text-xs uppercase tracking-wider font-medium transition-colors duration-200 hover:opacity-70 whitespace-nowrap cursor-pointer"
                style={{ color: '#2C2C2C', letterSpacing: '1.5px' }}
              >
                {item}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}